import { render, staticRenderFns } from "./CertificateProviderHealth.vue?vue&type=template&id=c36edbf6"
import script from "./CertificateProviderHealth.vue?vue&type=script&lang=js"
export * from "./CertificateProviderHealth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports